export default "__VITE_ASSET__CVPxUtH8__"